import Label from "components/Label/Label";
import React from "react";
import { FC } from "react";

export interface FormItemProps {
  className?: string;
  label?: string;
  desc?: string;
  required?: boolean;
}

const FormItem: FC<FormItemProps> = ({
  children,
  className = "",
  label,
  desc,
  required,
}) => {
  return (
    <div className={className}>
      {label && <Label>{label}</Label>}
      {" "}
      {required && <span className="text-red-500">*</span>}
      <div className="mt-1">{children}</div>
      {desc && (
        <span className="block mt-3 text-xs text-neutral-500 dark:text-neutral-400 ">
          {desc}
        </span>
      )}
    </div>
  );
};

export default FormItem;
